import $ from 'jquery';
import translations from '../translations';

export default function initAnalyzer() {
    let parent = $('.js-ar');
    let searchInput = $('#js-ar-search');
    let submitBtn = $('#js-ar-submit');
    let dataSection = $('.js-ar-result-parent');
    let diagramSection = $('.js-ar-diagram');
    let noResultSection = $('.js-ar-no-result');
    let resultSection = $('.js-ar-result');
    let notFoundSection = $('.js-ar-not-found');
    let ingredientsList = $('.js-ar-ingredients');
    let notFoundList = $('.js-ar-not-found-list');
    let searchVariantClass = 'js-ar-search-variant';
    let listOpenerClass = 'js-ar-list-opener';
    let listContentClass = 'js-ar-list-content';
    let apiUrl = '/umbraco/api/analyzer/getIngredients?ingredients=';
    let loading = false;

    dataSection.hide();

    parent.on('click', '.' + searchVariantClass + ', ' + '.' + listOpenerClass , function(e) {
        let target = $(this);
        if (target.is('.' + searchVariantClass)) {
            e.preventDefault();
            searchInput.val(target.html());
        }
        if (target.is('.' + listOpenerClass)) {
            e.preventDefault();
            target.toggleClass('active');
            target.closest('li').find('.' + listContentClass).toggleClass('active');
        }
    });

    submitBtn.on('click', function(e) {
        e.preventDefault();
        if (loading) return;
        dataSection.hide();
        resultSection.hide();
        notFoundSection.hide();
        noResultSection.hide();
        diagramSection.html('');
        ingredientsList.html('');
        notFoundList.html('');

        if (searchInput.val()) {
            loading = true;
            submitBtn.toggleClass('loading');
            $.ajax({
                method: "GET",
                url: apiUrl + searchInput.val(),
                error: function() {
                    loading = false;
                    submitBtn.toggleClass('loading');
                },
                success: function(response) {
                    loading = false;
                    submitBtn.toggleClass('loading');
                    dataSection.show();
                    if (response?.Result?.length > 0) {
                        resultSection.show();
                        renderDiagram(response.Result);
                        renderIngredientsList(response.Result);
                        if (response?.NotFound?.length > 0) {
                            notFoundSection.show();
                            renderNotFoundList(response.NotFound);
                        }
                    } else {
                        noResultSection.show();
                    }
                }
            });
        }
    });

    function ingredientColor(itemData) {
        let ewdValue = parseInt(itemData.Ewg);
        if (ewdValue <= 2) return 'green'
        if (ewdValue >=3 && ewdValue <= 6) return 'orange'
        if (ewdValue >=7) return 'red'
    }

    function renderDiagram(data) {
        data.forEach(function(itemData) {
            let htmlElement = `<div class="analyzer_diagram-area-box ${ingredientColor(itemData)}"></div>`;
            diagramSection.append(htmlElement);
        });
    }

    function renderIngredientsList(data) {
        let siteLanguage = getCurrentLanguage();

        data.forEach(function(itemData) {
            let htmlElement =
                `<li>
                    <div class="analyzer_ingredients-columns ${ingredientColor(itemData)}">
                        <div class="analyzer_ingredients-column name-column">
                            <div class="analyzer_ingredients-info">
                                <h3>${itemData.Name}</h3>
                                <span class="analyzer_ingredients-info-note">${itemData.Subname}</span>
                            </div>
                        </div>
                        <div class="analyzer_ingredients-column ewg-column">${itemData.Ewg}</div>
                        <div class="analyzer_ingredients-column bio-column">${itemData.Biodizionario}</div>
                        <div class="analyzer_ingredients-column add-column">
                            <a class="analyzer_ingredients-list-opener ${listOpenerClass}" href="#">
                                <span class="analyzer_ingredients-list-opener-text open">
                                    ${translations.ingredientsOpener[siteLanguage]}
                                </span>
                                <span class="analyzer_ingredients-list-opener-text close">
                                    ${translations.ingredientsClose[siteLanguage]}
                                </span>
                                <i class="icon-arrow-down"></i>
                            </a>
                        </div>
                    </div>
                    <div class="analyzer_ingredients-content-area ${listContentClass}">
                        <p>${itemData.Description}</p>
                    </div>
                </li>`;
            ingredientsList.append(htmlElement);
        });
    }

    function renderNotFoundList(data) {
        data.forEach(function(itemData, index) {
            let htmlElement =
                `<li>
                    ${index > 0 ? '<span>, </span>' : ''}
                    ${itemData}
                </li>`;
            notFoundList.append(htmlElement);
        });
    }

    function getCurrentLanguage() {
        var siteLanguage = ''

        switch (window.location.pathname.split('/')[1]) {
            case 'ru':
                siteLanguage = 'ru';
                break;
            case 'en':
                siteLanguage = "en"
                break;
            case 'pl':
                siteLanguage = "pl"
                break;
            case 'es':
                siteLanguage = "es"
                break;

            default:
                siteLanguage = "uk";
                break;
        }

        return siteLanguage;
    }
}
